"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _client = require("@searchkit/client");

var _Button = _interopRequireDefault(require("../../../../Button"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CustomValueFilter = function CustomValueFilter(_ref) {
  var filter = _ref.filter;
  var api = (0, _client.useSearchkit)();
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: function onClick() {
      api.removeFilter(filter);
      api.search();
    }
  }, filter.label, ": ", filter.value);
};

var _default = CustomValueFilter;
exports.default = _default;